import { Component, ViewChild } from "@angular/core";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { GlobalSubheaderDataService } from "../global-subheader-data.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { RequestModalComponent } from "../request-modal/request-modal.component";
import { Dictionary } from "src/app/store/models/common_types";
import { AppService } from "src/app/app.service";
import { ExportToExcelComponent } from "src/app/shared/export-to-excel/export-to-excel.component";
import { ExportToExcelService } from "src/app/shared/export-to-excel/export-to-excel.service";
import { CustomConsensusService } from "src/app/custom-consensus/custom-consensus.service";
import {
  VAIconRegistryService,
  eye,
  caretDown,
  bell,
  plus,
  unlock,
  addUser,
  cog,
  fileExcel,
  edit,
  fileExport,
} from "@va/core-library/icons";
import { faCaretUp } from "@fortawesome/pro-solid-svg-icons";
import { faSpinner } from "@fortawesome/pro-light-svg-icons";
import { Router } from "@angular/router";
import { PharmaDataService } from "src/app/pharma-page/pharma-data.service";
@Component({
  selector: "app-global-secondary-header",
  templateUrl: "./global-secondary-header.component.html",
  styleUrls: ["./global-secondary-header.component.scss"],
})
export class GlobalSecondaryHeaderComponent {
  title: string;
  sup: string;
  link: string;
  showSecondaryHeader: boolean;
  showCompanyNotes: boolean;
  ticker: string;
  exportTicker: string;
  sellsideBrokerShortName: string;
  isConsensusOnlyUser: boolean;
  showRequestNewBrokers = false;
  showRequestEntitlements = false;
  showWatchlist = false;
  pageName: string;
  isVisibleEntAndRequestBrokerModal = false;
  modalContext: string;
  visibleAlerts = false;
  showCustomConsensus = false;
  showAlerts = false;
  showCreateNewWatchlist = false;
  isVisibleWatchlistModal = false;
  showCreateCompsTable = false;
  showCreateCharts = false;
  watchlistMenuVisible: boolean;
  firmName: string;
  @ViewChild(RequestModalComponent)
  requestModal: RequestModalComponent;
  showManageWatchlistButton: boolean;
  showLabMenuButton: boolean;
  isVisibleManageWatchlistModal = false;
  alertsParams: Dictionary<any>;
  fBarPages: Array<string> = [
    "comps",
    "revisions",
    "surprise",
    "mex",
    "vsconsensus",
    "valuation",
    "tpr",
    "industry_metrics",
  ];
  exportToExcelPages: Array<string> = ["revisions", "surprise", "mex"];
  alertsSettingsPages: string[] = ["mex", "company"];
  customConsensusPages: string[] = ["NMV", "STD", "SCH"];
  disableActions = false;
  revisionExportDate = "";
  isVisibleEteModal = false;
  pageNavParams;
  isVisibleShortcutsModal = false;
  viewEntitlements = false;
  exportOptVisible = false;
  legacyUrl = `${window.caUrl}/app`;
  labParams: any;
  labs_menu_access = false;
  isLabsPage = false;
  isMegaMenuVisible = true;
  showCustomHeader = false;
  isExportInProgress = false;
  isColumnPickerModalVisible = false;
  isExportPopoverVisible = false;
  excelToExportDropdownOptions = [
    {
      label: "Values",
      id: 1,
      disabled: false,
    },
    {
      label: "Excel Add-In Formulas",
      id: 0,
      disabled: true,
    },
  ];
  disableMexPageExport = false;

  faCaretUp = faCaretUp;
  faSpinner = faSpinner;

  showCorporateEntitlements: boolean;
  showNewFbar: boolean = false;
  constructor(
    private store: Store<AppState>,
    private dataService: GlobalSubheaderDataService,
    private message: NzMessageService,
    private appService: AppService,
    private eteService: ExportToExcelService,
    private ccService: CustomConsensusService,
    private router: Router,
    private iconRegistry: VAIconRegistryService,
    private pharmaDataService: PharmaDataService,
  ) {
    this.iconRegistry.registerIcons([
      eye,
      caretDown,
      bell,
      plus,
      unlock,
      addUser,
      cog,
      fileExcel,
      edit,
      fileExport,
    ]);
  }

  setShowFbar(showFbar: boolean) {
    this.showNewFbar = showFbar;
  }
  ngOnInit() {
    this.store.select(stateGetter("globalSubheader")).subscribe((data) => {
      this.title = data.subheaderTitle;
      this.sup = data.superScript;
      this.link = data.link || [];
      this.pageName = data.pageName;
      this.showCompanyNotes =
        this.pageName === "company" || this.pageName === "mex";
      this.showSecondaryHeader =
        this.pageName !== "home" &&
        this.pageName !== "" &&
        this.pageName !== "comparative-analysis" &&
        this.pageName !== "industry_metrics" &&
        this.pageName !== "biopharma-database" &&
        this.pageName !== "biopharma-drug" &&
        this.pageName !== "search-page";
      this.showCustomHeader =
        this.pageName === "comparative-analysis" ||
        this.pageName === "industry_metrics" ||
        this.pageName === "biopharma-database" ||
        this.pageName === "biopharma-drug";
      this.showCustomConsensus =
        this.pageNavParams &&
        this.customConsensusPages.includes(this.pageNavParams.cut);
      this.showAlerts = this.alertsSettingsPages.includes(this.pageName);
      this.showWatchlist = this.pageName === "company";
      this.showManageWatchlistButton = this.pageName === "watchlist";
      this.showCreateNewWatchlist = this.pageName === "watchlist";
      this.showCreateCompsTable = this.pageName === "comps";
      this.showCreateCharts = this.pageName === "charts";
      this.isLabsPage = this.pageName === "labs";
      this.showLabMenuButton =
        this.pageName === "comps" ||
        this.pageName === "company" ||
        this.pageName === "broker" ||
        this.pageName === "analyst";

      this.disableActions = data.disableActions;
      this.revisionExportDate = data.revisionExportDate;
      if (
        this.pageName === "company" ||
        this.pageName === "research" ||
        this.pageName === "mex"
      ) {
        const url = window.location.pathname;
        this.ticker = url.split("/")[2].toUpperCase();
        this.alertsParams = {
          key: this.ticker,
          type: "company",
        };
      } else if (
        this.pageName === "revisions" ||
        this.pageName === "surprise" ||
        this.pageName === "vsconsensus" ||
        this.pageName === "valuation" ||
        this.pageName === "tpr"
      ) {
        this.ticker = window.location.pathname.split("/")[2].toUpperCase();
      }
      if (this.pageName === "comps") {
        const url = window.location.pathname;
        const compsId = url.split("/").length > 2 ? url.split("/")[3] : null;
        this.labParams =
          compsId === null ? null : { compsid: compsId, pageName: "comps" };
      }
      if (this.pageName === "company") {
        const url = window.location.pathname;
        const ticker = url.split("/").length > 1 ? url.split("/")[2] : null;
        this.labParams =
          ticker === null ? null : { ticker: ticker, pageName: "company" };
      }
      if (this.pageName === "broker") {
        const url = window.location.pathname;
        const sourceName = url.split("/").length > 2 ? url.split("/")[3] : null;
        this.labParams =
          sourceName === null
            ? null
            : { source: sourceName, pageName: "broker" };
      }
      if (this.pageName === "analyst") {
        const url = window.location.pathname;
        const analystId = url.split("/").length > 2 ? url.split("/")[3] : null;
        this.labParams =
          analystId === null
            ? null
            : { analystid: analystId, pageName: "analyst" };
      }

      this.setActionButtonsVisibilityAndContext();
    });

    this.store
      .select(stateGetter("globalHeader", "globalSettings"))
      .subscribe((data) => {
        this.sellsideBrokerShortName = data.sellsideBrokerShortname;
        this.isConsensusOnlyUser = data.isConsensusOnlyUser;
        this.firmName = data.firm_name;
        this.viewEntitlements = data.showEntitlementsPage;
        this.labs_menu_access = data.show_labs_secondarymenu || data.isSellside;
        this.showCorporateEntitlements = data.showCorporateEntitlements;
        if (data.showNavFB) {
          this.fBarPages.push("nav");
        }
      });
    this.store
      .select(stateGetter("navigationSettings", "pageParams", "ticker"))
      .subscribe((ticker: string) => {
        if (ticker !== undefined && ticker.length > 0) {
          this.exportTicker = ticker;
        }
      });

    this.store
      .select("navigationSettings", "pageParams")
      .subscribe((pageParams) => {
        this.watchlistMenuVisible = false;
        this.pageNavParams = pageParams;
        this.disableMexPageExport =
          this.pageNavParams.cut === "NMV" && window.MEData.currency !== "Base";
      });

    this.pharmaDataService.onPharmaFullExportInProgress.subscribe(
      (isExportInProgress) => {
        this.isExportInProgress = isExportInProgress;
      },
    );

    this.appService.onMexPageExcelDisableChange.subscribe((curr) => {
      this.disableMexPageExport =
        this.pageNavParams.cut === "NMV" && curr !== "Base";
    });
  }

  emitPharmaExportEvent() {
    // Emit the event when the button is clicked
    this.dataService.pharmaExcelExport.next();
    this.exportOptVisible = false;
  }
  hanldeColumnPickerClick() {
    this.isColumnPickerModalVisible = !this.isColumnPickerModalVisible;
  }

  setActionButtonsVisibilityAndContext() {
    // const url = window.location.pathname;
    switch (this.pageName) {
      case "company":
        this.showRequestNewBrokers = true;
        this.modalContext = "requestNewBroker";
        break;
      case "allbrokers":
        this.showRequestEntitlements = true;
        this.showRequestNewBrokers = true;
        break;
      case "watchlist":
        this.showRequestNewBrokers = false;
        this.showRequestEntitlements = false;
        this.showManageWatchlistButton = true;
        break;
      case "entitlements":
        this.showRequestNewBrokers = true;
        this.showRequestEntitlements = true;
        break;
      default:
        this.showRequestNewBrokers = false;
        this.showRequestEntitlements = false;
        break;
    }
  }

  openShowRequestNewBrokers() {
    //redirecting to entitlements page as hotfix
    // window.location.href = `${this.legacyUrl}/entitlements`;

    this.modalContext = "requestNewBroker";
    this.isVisibleEntAndRequestBrokerModal = true;
  }

  openShowRequestEntitlements() {
    //redirecting to entitlements page as hotfix
    // window.location.href = `${this.legacyUrl}/entitlements`;

    this.modalContext = "requestEntitlement";
    this.isVisibleEntAndRequestBrokerModal = true;
  }

  onCloseEntAndRequestBrokerModal() {
    this.modalContext = undefined;
    this.isVisibleEntAndRequestBrokerModal = false;
  }

  closeAlertsPopover(visible: boolean) {
    this.visibleAlerts = visible;
  }

  openCcModal() {
    this.ccService.showCcModal(true);
  }

  openWatchlistModal() {
    this.isVisibleWatchlistModal = true;
  }

  onCloseWatchlistModal() {
    this.isVisibleWatchlistModal = false;
  }

  openManageWatchlistModal() {
    this.isVisibleManageWatchlistModal = true;
  }

  closeManageWatchlistModal() {
    this.isVisibleManageWatchlistModal = false;
  }

  onCreateCompsTable() {
    this.dataService.onAction("createComps");
  }

  exportToExcel(exportType: number = null) {
    if (this.pageName === "mex") {
      //on mex pages trigger work flow on 'customize' / 'current view' click
      return;
    }

    if (
      this.pageName === "revisions" ||
      this.pageName === "surprise" ||
      this.pageName === "vsconsensus"
    ) {
      this.exportOptVisible = false;
      let extra = {};
      let feature = null;
      let page = null;
      switch (this.pageName) {
        case "revisions":
          if (this.revisionExportDate !== "")
            extra = { revisionDate: this.revisionExportDate };
          break;
        case "vsconsensus":
          extra = {
            source: this.sellsideBrokerShortName,
            export_type: exportType,
            template_type: "VS Consensus",
          };
          feature = "VSCONSENSUS_EXCEL_EXPORT";
          page = "VSConsensus Page";
          break;
        default:
          break;
      }
      this.appService
        .exportToExcel(this.pageName, this.exportTicker, extra)
        .subscribe((res) => {
          if (res["status"] === "success") {
            const fileName = res["filename"];
            const trackerId = res["trackerid"];
            this.appService.logUserAction(
              {},
              this.ticker,
              "",
              feature,
              {
                PAGE: page,
                ticker: this.ticker,
                beginning_state_referrer: "Company page",
                export_type: exportType,
                tracker_id: trackerId,
                file_name: fileName,
              },
              "Consensus",
              "EXPORT_BUTTON_CLICKED",
            );
          }
        });
    }
  }

  onEteCurrentViewClick(eteModal: ExportToExcelComponent) {
    if (this.pageName.toLocaleLowerCase() !== "mex") {
      return;
    }
    //handle current view generation here
    this.eteService
      .getNextExportStatus(this.pageNavParams.ticker, "NMV", "IS")
      .subscribe((response: any) => {
        if (response.status === "success" && response.allow_export) {
          eteModal.exportCurrentView();
        } else {
          //show notification for export not allowed
          eteModal.createExportNotAllowedNotification();
        }
      });
  }
  onCreateCharts() {
    this.dataService.onAction("createCharts");
  }

  onEteCustomizeClick(eteModal: ExportToExcelComponent) {
    if (this.pageName.toLocaleLowerCase() !== "mex") {
      return;
    }
    //enable pop up here
    this.eteService
      .getNextExportStatus(this.pageNavParams.ticker, "NMV", "IS")
      .subscribe((response: any) => {
        if (response.status === "success" && response.allow_export) {
          this.isVisibleEteModal = true;
        } else {
          //show notification for export not allowed
          eteModal.createExportNotAllowedNotification();
        }
      });
  }

  onCloseEteModal() {
    this.isVisibleEteModal = false;
  }

  onCloseShortcutsModal(isOpen: boolean) {
    this.isVisibleShortcutsModal = isOpen;
  }
  routeToBioPharmaPage() {
    this.router.navigate([`/biopharma/database`]);
  }
}
